import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SendEmailService {

  // URL of Rest API to send email
  private url = 'https://rsbusinesstech-backend.onrender.com/contact/sendEmail';
  // private url = 'http://127.0.0.1:8080/contact/sendEmail';

  constructor(private httpClient: HttpClient) { }

  // Calling REST API to send email
  sendEmail(request: any): Observable<string> {
    return this.httpClient.post(this.url, request, { responseType: 'text'}
    );
  }
}